<div class="mb-4 flex flex-wrap items-start justify-between gap-4">
	<div class="text-base font-bold text-black">Pending Rating List</div>
	<app-cbta-daterange-filter
		[startDate]="startDate"
		[endDate]="endDate"
		(dateRangeSelected)="handleDateRangeChange($event)"
	></app-cbta-daterange-filter>
</div>

<!-- Forms List -->
<div class="cbta-tbl forms-tbl">
	<div class="columns">
		<div class="column col-12">
			<ngx-table
				[configuration]="configuration"
				[data]="forms"
				[noResultsTemplate]="noResultsTemplate"
				[columns]="columns"
				[pagination]="pagination"
				(event)="onTableChanged($event)"
			>
			</ngx-table>
		</div>

		<!-- <ng-template #cbTpl let-row let-rowIndex="rowIndex">
      <div class="pr-4">
        <mat-checkbox></mat-checkbox>
      </div>
    </ng-template> -->

		<ng-template #trainingNameTpl let-row let-rowIndex="rowIndex">
			<div class="flex"></div>
			<div class="font-medium text-red">{{ row.trainingInformation?.candidates[0]?.name }}</div>
			<div class="font-bold">{{ row.formDetails?.name }}</div>
			@if (row.__legacy) {
				<span class="cbta-status rounded px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide"> Legacy </span>
			}
		</ng-template>

		<!-- <ng-template #statusTpl let-row let-rowIndex="rowIndex">
      <span class="cbta-status font-medium px-3 py-0.5 rounded text-xs">
        {{ row.version }}
      </span>
    </ng-template> -->
		<ng-template #sessionTpl let-row let-rowIndex="rowIndex">
			<span>{{ getSessionConfig($safeNavigationMigration(row?.formDetails?.sessionDetails)) }}</span>
		</ng-template>

		<ng-template #dateTpl let-row let-rowIndex="rowIndex">
			<span class="text-violet">{{ formatDate(row.lastUpdatedDate) }}</span>
		</ng-template>

		<ng-template #actionTpl let-row let-rowIndex="rowIndex">
			<div class="flex justify-center space-x-2">
				<button
					class="aa-btn"
					data-size="small"
					data-variant="secondary"
					(click)="goToRatingForm($safeNavigationMigration(row.formDetails?.id), row.id)"
					matTooltip="Continue"
				>
					Continue
				</button>
				<button
					class="aa-btn"
					data-size="small"
					data-variant="secondary"
					(click)="deletePendingSession(row.id)"
					matTooltip="Delete"
				>
					Delete
				</button>
			</div>
		</ng-template>

		<ng-template #noResultsTemplate>
			@if (columns) {
				<td [attr.colspan]="columns.length" class="h-[180px] text-center">
					<span class="text-grey-40">No results found.</span>
				</td>
			}
		</ng-template>
	</div>
</div>
